import { displayDate } from '../services/textService';

const DateCell = ({ cell }) => displayDate(new Date(cell.value));

export default DateCell;
